var map = {
	"./template.bet575": 2066,
	"./template.bet575.tsx": 2066,
	"./template.bet777": 2067,
	"./template.bet777.tsx": 2067,
	"./template.betprofessor": 2068,
	"./template.betprofessor.tsx": 2068,
	"./template.betroyale": 2069,
	"./template.betroyale.tsx": 2069,
	"./template.betstride": 2070,
	"./template.betstride.tsx": 2070,
	"./template.buffalobet": 2071,
	"./template.buffalobet.tsx": 2071,
	"./template.chromabet": 2072,
	"./template.chromabet.tsx": 2072,
	"./template.default": 672,
	"./template.default.tsx": 672,
	"./template.epicodds": 2073,
	"./template.epicodds.tsx": 2073,
	"./template.fiestabet": 2074,
	"./template.fiestabet.tsx": 2074,
	"./template.forsport": 1630,
	"./template.forsport.tsx": 1630,
	"./template.gigabet": 2075,
	"./template.gigabet.tsx": 2075,
	"./template.goldenbet888": 2076,
	"./template.goldenbet888.tsx": 2076,
	"./template.goldenrush": 2077,
	"./template.goldenrush.tsx": 2077,
	"./template.hyperbet": 2078,
	"./template.hyperbet.tsx": 2078,
	"./template.juicybet": 2079,
	"./template.juicybet.tsx": 2079,
	"./template.junglebet": 2080,
	"./template.junglebet.tsx": 2080,
	"./template.magnumbet": 2081,
	"./template.magnumbet.tsx": 2081,
	"./template.oldgill": 2082,
	"./template.oldgill.tsx": 2082,
	"./template.puntcity": 2083,
	"./template.puntcity.tsx": 2083,
	"./template.puntgenie": 2084,
	"./template.puntgenie.tsx": 2084,
	"./template.pyramidbet": 2085,
	"./template.pyramidbet.tsx": 2085,
	"./template.questbet": 2086,
	"./template.questbet.tsx": 2086,
	"./template.slambet": 2087,
	"./template.slambet.tsx": 2087,
	"./template.sterlingparker": 2088,
	"./template.sterlingparker.tsx": 2088,
	"./template.sugarcastle": 2089,
	"./template.sugarcastle.tsx": 2089,
	"./template.templebet": 2090,
	"./template.templebet.tsx": 2090,
	"./template.titanbet": 2091,
	"./template.titanbet.tsx": 2091,
	"./template.ts": 985,
	"./template.vikingbet": 2092,
	"./template.vikingbet.tsx": 2092,
	"./template.volcanobet": 2093,
	"./template.volcanobet.tsx": 2093,
	"./template.wellbet": 2094,
	"./template.wellbet.tsx": 2094
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2467;